// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-cell {
  color: dimgray !important;
}

.main-col {
  color: black !important;
  font-weight: bolder;
}

.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {
  color: rgba(0, 0, 0, 0.54);
}

.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__trailing,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__notch,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__leading {
  border: none !important;
}

.mat-mdc-dialog-content {
  height: 100%;
}

mat-form-field {
  width: 100%;
}

.mat-mdc-dialog-actions[align=end] {
  justify-content: flex-end;
}

.bt-spinner {
  display: inline;
  padding-right: 30px;
}

.first-field {
  margin-top: 15px;
}

.fixActionRow {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.spacer {
  flex-grow: 1;
}

.strong {
  font-weight: bolder;
}

.mat-mdc-chip.mat-mdc-standard-chip {
  background-color: #32c5d2;
  color: white;
}

.first-field {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

editable-grid-field::ng-deep table thead tr th {
  font-weight: bolder;
  vertical-align: top;
}
editable-grid-field::ng-deep table thead tr th:not(:first-child) {
  text-align: right;
}
editable-grid-field::ng-deep table tbody tr td:first-child {
  font-weight: bolder;
}
editable-grid-field::ng-deep table tbody tr td:not(:first-child) * {
  text-align: right;
}
editable-grid-field::ng-deep table tbody td.mat-column-percent {
  font-style: italic;
}
editable-grid-field::ng-deep table .value > div {
  width: 100%;
}
editable-grid-field::ng-deep table .budget-method-default {
  color: #c5c4c4 !important;
}

.warning {
  border: 1px solid #A8488D;
  padding: 10px;
  border-radius: 4px;
  background-color: rgba(168, 72, 141, 0.0509803922);
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 20px;
}

.align-end {
  margin-left: auto;
}

.mdc-dialog__title {
  padding: 24px 24px 9px;
}

.mdc-dialog__actions {
  padding: 8px 24px 20px 24px;
}

.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.scss","webpack://./src/app/modules/admin/admonitorings/components/match-admo-dialog/match-admo-dialog.component.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;ACzEF;;AD2EA;EACE,uBAAA;EACA,mBAAA;ACxEF;;AD2EA;EACE,0BAAA;ACxEF;;AD6EM;;;EAII,uBAAA;AC3EV;;AAdA;EACI,YAAA;AAiBJ;;AAdA;EACI,WAAA;AAiBJ;;AAdA;EACI,yBAAA;AAiBJ;;AAdA;EACI,eAAA;EACA,mBAAA;AAiBJ;;AAdA;EACI,gBAAA;AAiBJ;;AAdA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AAiBJ;;AAdA;EACI,YAAA;AAiBJ;;AAdA;EACI,mBAAA;AAiBJ;;AAdA;EACI,yBAAA;EACA,YAAA;AAiBJ;;AAdA;EACI,gBAAA;AAiBJ;;AAdA;EACI,iBAAA;AAiBJ;;AAdA;EACI,kBAAA;AAiBJ;;AAVgB;EACI,mBAAA;EACA,mBAAA;AAapB;AAXgB;EACI,iBAAA;AAapB;AAPgB;EACI,mBAAA;AASpB;AANoB;EACI,iBAAA;AAQxB;AAHgB;EACI,kBAAA;AAKpB;AAAQ;EACI,WAAA;AAEZ;AAAQ;EACI,yBAAA;AAEZ;;AAGA;EACI,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,kDAAA;EAEA,gBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,sBAAA;AADJ;;AAIA;EACI,2BAAA;AADJ;;AAIA;EACI,YAAA;AADJ","sourcesContent":["@use '@angular/material' as mat;\n// theme.scss\n\n$my-app: (\n  10:  #e8fafb2e,\n  50:  #32c5d22e,\n  100: #32c5d23d,\n  200: orange,\n  300: #32c5d25c,\n  400: #8cdce4,\n  500: #32c5d2c2,\n  600: #32c5d2,\n  700: #1f858e,\n  800: #18666d,\n  900: #337ab7,\n  A100: #ffffff,\n  A200: #def6f8,\n  A400: #a1f3fb,\n  A700: #7aecf7,\n  contrast: (\n    50 : #32c5d25c,\n    100 : #32c5d2c2,\n    200 : white,\n    300 : #1f858e,\n    400 : #18666d,\n    500 : #337ab7,\n    600 : #ffffff,\n    700 : #ffffff,\n    800 : #ffffff,\n    900 : #ffffff,\n    A100 : #32c5d2,\n    A200 : #1f858e,\n    A400 : #18666d,\n    A700 : #337ab7,\n  ));\n\n$my-app-primary: mat.m2-define-palette($my-app, 600);\n$my-app-accent : mat.m2-define-palette($my-app, 900);\n$my-app-warn : mat.m2-define-palette($my-app, 200);\n$my-app-sidebar : mat.m2-define-palette($my-app, 10);\n$my-app-background : mat.m2-define-palette($my-app, 50);\n$my-app-colored-card : mat.m2-define-palette($my-app, 100);\n$my-app-light : mat.m2-define-palette($my-app, 200);\n\n\n$comv-typography-config: mat.m2-define-typography-config(\n\n  $body-1: mat.m2-define-typography-level(14px, 21px, 400) \n  // ...\n);\n\n$my-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $my-app-primary,\n    accent: $my-app-accent,\n    warn: $my-app-warn\n  ),\n  typography: $comv-typography-config,\n  density: 0,\n));\n\n$comv-dark-blue: #26344B;\n$comv-middle-blue: #337ab7;\n$comv-primary-blue: #32c5d2;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab1: #0175c0;\n$comv-tab2: #009BC6;\n$comv-ultralight-gray: rgba(242, 242, 242, 0.15); \n$comv-table-header-border: #a8b7c1;\n\n\n.mat-mdc-cell {\n  color:dimgray !important;\n}\n.main-col {\n  color: black !important;\n  font-weight: bolder;\n}\n\n.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mat-mdc-paginator::ng-deep {\n  .mdc-text-field::ng-deep {\n      .mdc-notched-outline__trailing,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__leading\n       {\n          border: none !important;\n      }\n  }\n}\n\n$comv-blue-dark :#04488f;\n$comv-blue-medium :#0175c0;\n$comv-blue-light :#00b0e1;\n$comv-gray-medium :#8f8f8f;\n$comv-yellow-light :#ecb842;\n$comv-yellow-dark :#e6a540;\n$comv-pink-light :#aa488d;\n$comv-pink-dark :#7d478e;\n$comv-green-light :#8db854;\n$comv-green-dark :#54763f;\n\n\n//$comv-dark-blue: #26344B;\n// $comv-dark-blue : $comv-blue-dark;\n\n//$comv-middle-blue: #337ab7;\n$comv-middle-blue: $comv-blue-medium;\n//$comv-primary-blue: #28b5b9;  \n$comv-primary-blue: $comv-blue-light;\n\n$comv-primary-blue-hover: #32c5d2;  \n\n//$comv-accent-blue: #0065AF;\n$comv-accent-blue: $comv-blue-medium;\n$comv-accent-blue-hover: #0075C9;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-light-blue3: #009BC6; \n$comv-light-blue3-hover: #00b3e3;\n\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab-icon:$comv-middle-blue;\n$comv-tab-icon-hover:$comv-primary-blue;\n\n$comv-grid-highlight: #f6f6f6;\n$comv-grid-hover: #D7F3FB;\n\n$comv-chips-color: $comv-light-gray;\n\n$comv-admo-matched: greenyellow;\n$comv-admo-disabled: lightgray;\n$comv-admo-validated: green;\n$comv-admo-published: $comv-primary-blue;\n$comv-admo-split: #7e478e87;\n$comv-admo-merge: #ffa500;","@use '@angular/material' as mat;\n@import \"./../../../../../../theme/theme.scss\";\n\n.mat-mdc-dialog-content {\n    height: 100%;\n}\n\nmat-form-field {\n    width:100%;\n}\n\n.mat-mdc-dialog-actions[align=end] {\n    justify-content: flex-end;\n}\n\n.bt-spinner {\n    display: inline;\n    padding-right: 30px;\n}\n\n.first-field {\n    margin-top: 15px;\n}\n\n.fixActionRow {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.spacer {\n    flex-grow: 1;\n}\n\n.strong {\n    font-weight: bolder;\n}\n\n.mat-mdc-chip.mat-mdc-standard-chip {\n    background-color: mat.m2-get-color-from-palette($my-app-primary);\n    color: white;\n}\n\n.first-field {\n    margin-top: 15px;\n}\n\n.text-right {\n    text-align: right;\n}\n\n.text-center {\n    text-align: center;\n}\n\neditable-grid-field::ng-deep {\n    table {\n        thead{\n            tr {\n                th {\n                    font-weight: bolder;\n                    vertical-align: top;\n                }\n                th:not(:first-child) {\n                    text-align: right;\n                }\n            }\n        }\n        tbody {\n            tr {\n                td:first-child {\n                    font-weight: bolder;\n                }\n                td:not(:first-child) {\n                    *{\n                        text-align: right;\n                    }\n                }\n            }\n            td {\n                &.mat-column-percent {\n                    font-style: italic;\n                }\n            }\n        }\n\n        .value > div {\n            width: 100%;\n        }\n        .budget-method-default {\n            color: #c5c4c4!important;\n        }\n    }\n}\n\n.warning {\n    border: 1px solid #A8488D;\n    padding: 10px;\n    border-radius: 4px;\n    background-color: #A8488D0d;\n    // text-align: center;\n    font-weight: 400;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.align-end {\n    margin-left: auto;\n}\n\n.mdc-dialog__title {\n    padding: 24px 24px 9px;\n}\n\n.mdc-dialog__actions {\n    padding: 8px 24px 20px 24px;\n}\n\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label {\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
